import { useState } from "react";
import { cn } from "@/lib/utils";

type ImagePriority = "high" | "low" | "auto";

interface OptimizedImageProps {
  src: string;
  alt: string;
  className?: string;
  wrapperClassName?: string;
  aspectRatio?: string;
  loading?: "lazy" | "eager";
  fetchPriority?: ImagePriority;
  sizes?: string;
  width?: number;
  height?: number;
  /** Imagem principal (LCP): eager + high priority */
  priority?: boolean;
}

export function OptimizedImage({
  src,
  alt,
  className,
  wrapperClassName,
  aspectRatio = "16 / 10",
  loading,
  fetchPriority,
  sizes = "(max-width: 768px) 100vw, (max-width: 1280px) 66vw, 800px",
  width,
  height,
  priority = false,
}: OptimizedImageProps) {
  const [loaded, setLoaded] = useState(false);
  const resolvedLoading = loading ?? (priority ? "eager" : "lazy");
  const resolvedPriority = fetchPriority ?? (priority ? "high" : "auto");

  return (
    <div
      className={cn("overflow-hidden bg-brand-surface-container", wrapperClassName)}
      style={wrapperClassName?.includes("absolute") ? undefined : { aspectRatio }}
    >
      <img
        src={src}
        alt={alt}
        className={cn(
          "h-full w-full object-cover",
          // Só opacity (composta). Prioridade: sem fade que atrasa LCP.
          !priority && "transition-opacity duration-300 ease-out",
          priority || loaded ? "opacity-100" : "opacity-0",
          className,
        )}
        loading={resolvedLoading}
        decoding="async"
        fetchPriority={resolvedPriority}
        sizes={sizes}
        width={width}
        height={height}
        onLoad={() => setLoaded(true)}
      />
    </div>
  );
}
